import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const useSettings = () => {
  return useQuery({
    queryKey: ['settings'],
    queryFn: async () => {
      // Fetch main settings
      const { data: settingsData } = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/settings`
      );
      // Fetch pipeline stages mapping
      let pipelineStages = {};
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/pipeline-stages`);
        pipelineStages = data;
      } catch (e) {
        // fallback: leave empty if error
      }
      return {
        ...settingsData,
        pipedrive_pipeline_stages: pipelineStages
      };
    }
  });
};

export const updateSettings = async (id, data) => {
  return await axios.put(`${process.env.REACT_APP_API_BASE_URL}/settings/${id}`, {
    text: data
  });
};

export const updateBankCommissions = async (data) => {
  return await axios.put(`${process.env.REACT_APP_API_BASE_URL}/settings/bank_commissions`, data);
};

export const updateUtmCampaigns = async (data) => {
  return await axios.put(`${process.env.REACT_APP_API_BASE_URL}/settings/utm_campaigns`, data);
};
